<template>
    <default-layout>

        <div class="row">
            <div class="col-12">
                <h1 class="h4 mb-4 clearfix">
                    Settings
                </h1>
            </div>
        </div>

        <div class="row container mx-auto">
            <div class="col-md-6">
                <div class="list-group">
                    <router-link to="/settings/export" class="list-group-item list-group-item-action d-flex align-items-center">
                        <font-awesome-icon class="fa-2x mr-3" icon="file-export"/>
                        Export
                    </router-link>
                </div>
            </div>
        </div>

    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";

    export default {
        name: "SettingsPage",
        components: {DefaultLayout}
    }
</script>

<style scoped>

</style>